export const PRODUCT_USAGE_CHART_DATA_KEY = 'dataKey';
